export enum Tab {
  summary = 'summary',
  originalText = 'originalText',
}

export const tabList = [
  {
    id: Tab.summary,
    value: '智能总结',
  },
  {
    id: Tab.originalText,
    value: '原文',
  },
];
